// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import "./common.css";

import { AdministratorDocument, SchoolDocument } from "../store/schema";
import { randomElement } from "../util";
import { ErrorBoundary } from "./ErrorBoundary";

interface PageFooterProps {
  administrators: AdministratorDocument[];
  isCoordinator: boolean;
  school: SchoolDocument | null;
}

export const PageFooter: React.FC<PageFooterProps> = props => {
  const { administrators, isCoordinator, school } = props;

  const coordEmail = school == null ? null : school.data.coordinatorEmail;
  const admin =
    administrators.length === 0 ? null : randomElement(administrators);
  const adminEmail = admin == null ? null : admin.data.email;

  return (
    <ErrorBoundary>
      <div className="page-footer">
        {(coordEmail != null || admin != null) && (
          <div className="help-heading">Support:</div>
        )}
        {!isCoordinator && coordEmail != null && (
          <div className="help-item">
            <span>Questions? </span>
            <a target="_top" href={`mailto:${coordEmail}`}>
              {coordEmail}
            </a>
          </div>
        )}
        {adminEmail != null && (
          <div className="help-item">
            <span>Site broken? </span>
            <a target="_top" href={encodeURI(`mailto:${adminEmail}`)}>
              {adminEmail}
            </a>
          </div>
        )}
        {!isCoordinator && (
          <div className="help-item">
            Note: this is beta software.
            You should keep a copy of your hours somewhere safe, just in case.
            </div>
        )}
      </div>
    </ErrorBoundary>
  );
};
